import aiToolsHomePage from '../assets/home_page_assets/ai-tools-home-page.webp';

export const whyChooseFeatureCards = [
  {
    id: 'platform',
    title: 'Complete AI Home Design Platform',
    text: 'Plan and visualize interiors, exteriors, gardens, floor plans, and room renders from one connected platform. MyRoomsAI brings multiple design tools together so users can move from idea to realistic visual result without switching between different apps.',
    ctaLabel: 'Explore AI Tools',
    ctaTo: '/features',
    imageSide: 'left',
    imageSrc: aiToolsHomePage,
    imageAlt: 'MyRoomsAI AI home design tools overview',
  },
];
